<template>
  <div id="page-camera-sort">
    <div class="vx-card p-6">
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        class="ag-theme-material ag-grid-table"
        style="min-height: calc(100vh - 220px)"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :components="components"
        rowSelection="multiple"
        colResizeDefault="shift"
        :floatingFilter="false"
        :enableRtl="$vs.rtl"
        :rowDragManaged="true"
        :animateRows="true"
        :suppressDragLeaveHidesColumns="true"
        :rowData="cameras"
      >
      </ag-grid-vue>

      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button
          id="button-with-loading"
          type="filled"
          @click="saveSort"
          class="mt-5 block"
          >登録する</vs-button
        >
        <vs-button
          type="border"
          class="mt-5 block"
          :to="{
            name: 'enterprise-management-camera-list',
          }"
          >キャンセル</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { DeviceInfoMixin } from "@/mixins";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseCameraList",
);

export default {
  components: {
    AgGridVue,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      searchCondition: {},
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "社員が見つかりませんでした" },
        context: {
          componentParent: this,
        },
        suppressCellSelection: true,
      },
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: null,
      components: {},
    };
  },
  computed: {
    ...mapState({
      cameras: (state) => state.cameras,
    }),
  },
  watch: {
    onChangeWindowSize() {
      if (this.gridApi) {
        this.$nextTick(async () => {
          this.gridApi.sizeColumnsToFit();
        });
      }
    },
  },
  methods: {
    ...mapActions([
      "fetchCameras",
      "updateCamerasSortOrder",
      "resetCameraListState",
    ]),

    async searchCameras() {
      this.$vs.loading();
      try {
        await this.fetchCameras();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    async saveSort() {
      let camerasListData = this.gridApi
        .getModel()
        .rowsToDisplay.map((displayRow) => displayRow.data);
      let payload = {
        sort_orders: camerasListData.map((camera, index) => {
          return { enterprise_camera_id: camera.id, sort_order: index + 1 };
        }),
      };
      this.$vs.loading({
        type: "default",
        container: "#button-with-loading",
        scale: 0.45,
      });
      try {
        await this.updateCamerasSortOrder(payload);
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.$router.push({ name: "enterprise-management-camera-list" });
      } catch (e) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "表示順序の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    cleanup() {
      this.resetCameraListState();
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        rowDrag: true,
        headerName: "",
        width: 30,
        field: "",
      },
      {
        headerName: "ID",
        field: "id",
        width: 110,
      },
      {
        headerName: "名前",
        field: "name",
        width: 220,
      },
      {
        headerName: "備考",
        field: "description",
        width: 250,
      },
    ];
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "0.8rem 0 0 0.8rem";
    let routerHeaderElement = document.getElementsByClassName("router-header");
    routerHeaderElement[0].style["margin-bottom"] = "0.2rem";

    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container",
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
    this.$nextTick(async () => {
      this.gridApi.sizeColumnsToFit();
    });
  },
  created() {
    this.searchCameras();
  },
  beforeDestroy() {
    this.cleanup();
  },
};
</script>

<style lang="scss" scoped>
#page-camera-sort {
  margin-right: 1rem;
  .ag-theme-material {
    height: calc(100vh - 190px);
  }
  .vs-button {
    margin: 0.5rem;
  }
}
</style>
